import React, { useState } from "react";
import Footer from "../components/Footer";
import HeroSection from "../components/HeroSection";
import InfoSection from "../components/InfoSection";
import {
  individualsHeroSection, businessHeroSection,
  individualsOne, individualsTwo, individualsThree,
  businessOne, businessTwo, businessThree,
  individualsServices, businessServices
} from "../components/InfoSection/Data";
import Navbar from "../components/Navbar";
import { Services } from "../components/Services";
import { Projects } from "../components/Projects";
import Sidebar from "../components/SideBar";
import ModeSwitch from "../components/ModeSwitch";

const Home = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [business, setBusiness] = useState(false);

  const toggle = () => setIsOpen(!isOpen);
  const toggleBusiness = () => setBusiness(!business);

  let heroSectionInfo = business ? businessHeroSection : individualsHeroSection;
  let one = business ? businessOne : individualsOne;
  let two = business ? businessTwo : individualsTwo;
  let three = business ? businessThree : individualsThree;
  let services = business ? businessServices : individualsServices;

  return (
    <>
      <Sidebar isOpen={isOpen} toggle={toggle} />
      <Navbar toggle={toggle} />
      <ModeSwitch onChange={(mode) => toggleBusiness(mode)} />
      <HeroSection {...heroSectionInfo}/>
      <InfoSection {...one} />
      <InfoSection {...two} />
      <Services {...services}/>
      <Projects />
      <InfoSection {...three} />
      <Footer />
    </>
  );
};

export default Home;
